import { apiSlice } from "./apiSlice";

const trackingApi = apiSlice
  .enhanceEndpoints({ addTagTypes: ["TrackingAccounts", "OceanTracking"] })
  .injectEndpoints({
    endpoints: builder => ({
      getTrackingAccounts: builder.query({
        query: () => "/api_integration/tracking_accounts/",
        providesTags: ["TrackingAccounts"],
      }),
      saveTrackingAccount: builder.mutation({
        query: ({ id, ...body }) => ({
          url: `/api_integration/tracking_accounts/${id ? `${id}/` : ""}`,
          method: id ? "PATCH" : "POST",
          body,
        }),
        invalidatesTags: ["TrackingAccounts", "OceanTracking", "Onboarding"],
      }),
      deleteTrackingAccount: builder.mutation({
        query: id => ({
          url: `/api_integration/tracking_accounts/${id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["TrackingAccounts", "OceanTracking"],
      }),
      testTrackingAccount: builder.mutation({
        query: id => ({
          url: `/api_integration/tracking_accounts/${id}/test_connection/`,
          method: "POST",
        }),
        invalidatesTags: ["TrackingAccounts", "Onboarding"],
      }),
      getOceanTrackingIntegrations: builder.query({
        query: (trackingType = "container") =>
          `/api/shipment/tracking/subscriptions/integrations/?tracking_type=${trackingType}`,
        providesTags: ["TrackingAccounts"],
      }),
      getOceanTracking: builder.query({
        query: ({ shipment, shipmentLeg, consignment, offset = 0 }) =>
          `/api/shipment/tracking/subscriptions/?${new URLSearchParams({ ...(shipment ? { shipment } : {}), ...(shipmentLeg ? { shipment_leg: shipmentLeg } : {}), ...(consignment ? { consignment } : {}), offset, limit: 20 })}`,
        providesTags: ["OceanTracking"],
      }),
      createOceanTracking: builder.mutation({
        query: body => ({ url: "/api/shipment/tracking/subscriptions/", method: "POST", body }),
        invalidatesTags: ["OceanTracking", "Onboarding"],
      }),
      updateOceanTracking: builder.mutation({
        query: ({ id, ...body }) => ({
          url: `/api/shipment/tracking/subscriptions/${id}/`,
          method: "PATCH",
          body,
        }),
        invalidatesTags: ["OceanTracking"],
      }),
      oceanTrackingAction: builder.mutation({
        query: ({ id, action, ...body }) => ({
          url: `/api/shipment/tracking/subscriptions/${id}/${action}/`,
          method: "POST",
          body,
        }),
        invalidatesTags: ["OceanTracking"],
      }),
      getOceanTrackingHistory: builder.query({
        query: ({ id, kind, offset = 0 }) =>
          `/api/shipment/tracking/subscriptions/${id}/${kind}/?limit=50&offset=${offset}`,
        providesTags: ["OceanTracking"],
      }),
    }),
  });

export const {
  useGetTrackingAccountsQuery,
  useSaveTrackingAccountMutation,
  useDeleteTrackingAccountMutation,
  useTestTrackingAccountMutation,
  useGetOceanTrackingIntegrationsQuery,
  useGetOceanTrackingQuery,
  useCreateOceanTrackingMutation,
  useUpdateOceanTrackingMutation,
  useOceanTrackingActionMutation,
  useGetOceanTrackingHistoryQuery,
} = trackingApi;
